import Konva from "konva";
import { Line } from "konva/lib/shapes/Line";

export class RemoteSensorWireKonva {
  static init(transmitterIcon: Konva.Image, remoteSensorIcon: Konva.Image) {
    const line = new Line();
    line.points(this.calculatePoints(transmitterIcon, remoteSensorIcon));
    line.stroke("#002766");
    return line.strokeWidth(3);
  }

  static calculatePoints(transmitterIcon: Konva.Image, remoteSensorIcon: Konva.Image) {
    const transmitterCenterX = transmitterIcon.x() + (transmitterIcon.width() * transmitterIcon.scaleX()) / 2;
    const transmitterCenterY = transmitterIcon.y() + (transmitterIcon.height() * transmitterIcon.scaleY()) / 2;
    const remoteSensorCenterX = remoteSensorIcon.x() + (remoteSensorIcon.width() * remoteSensorIcon.scaleX()) / 2;
    const remoteSensorCenterY = remoteSensorIcon.y() + (remoteSensorIcon.height() * remoteSensorIcon.scaleY()) / 2;

    const dx = remoteSensorCenterX - transmitterCenterX;
    const dy = remoteSensorCenterY - transmitterCenterY;
    const angle = Math.atan2(dy, dx);

    const transmitterRadius = (transmitterIcon.width() * transmitterIcon.scaleX()) / 2 + 5;
    const remoteSensorRadius = (remoteSensorIcon.width() * remoteSensorIcon.scaleX()) / 2 + 5;

    return [
      transmitterCenterX - transmitterRadius * Math.cos(angle + Math.PI),
      transmitterCenterY - transmitterRadius * Math.sin(angle + Math.PI),
      remoteSensorCenterX - remoteSensorRadius * Math.cos(angle),
      remoteSensorCenterY - remoteSensorRadius * Math.sin(angle),
    ];
  }

  static updateWire(wire: Konva.Line, transmitterIcon: Konva.Image, remoteSensorIcon: Konva.Image) {
    wire.points(this.calculatePoints(transmitterIcon, remoteSensorIcon));
  }
}
